
export class UserSetting {
  constructor({
        id= null,
        keycloakId= ``, 
        name= ``, 
        mobile= ``,
        mail= ``,
        password= ``,
        roles=[{roleName:'',location:''}],
        active= ``,
        description= ``
    } = {}) {
    this.id = id;
    this.keycloakId = keycloakId;
    this.name = name;
    this.mobile = mobile;
    this.mail = mail;
    this.password = password;
    this.roles = roles;
    this.active = active;
    this.description = description;
  }
}
export function newEntity() {
  return new UserSetting();
}
export function gridFields() {
  return Object.freeze([
    // {
    //   key: 'id',
    //   label: 'lbl.user.name',
    //   form: {
    //     type: 'input'
    //   }
    // },
      {
        key: 'name',
        label: 'lbl.user.name',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'mobile',
        label: 'lbl.user.mobile',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'mail',
        label: 'lbl.user.mail',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'roles',
        label: 'lbl.user.role',
        sortable: true,
        form: {
          type: 'detailTable'
        }
      },
      // {
      //   key: 'description',
      //   label: 'lbl.basic.description',
      //   sortable: true,
      //   form: {
      //     type: 'input'
      //   }
      // }     
  ]);
}
export const fields = Object.freeze(Object.keys(new UserSetting()).map(i => 'entity.' + i));
export const filterFields = [
  'filter.nameFilter',
  'filter.activeFilter'
];
export const filter = {
  'nameFilter': "",
  'activeFilter': ""
};
